import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {IsAdminGuard} from '../security/is-admin.guard';
import {TechnicalApplicationListComponent} from './technical-application-list/technical-application-list.component';
import {TechnicalApplicationEditComponent} from './technical-application-edit/technical-application-edit.component';
import {TechnicalApplicationResolver} from './technical-application.resolver';
import {TechnicalApplicationCreateComponent} from './technical-application-create/technical-application-create.component';


const routes: Routes = [
  {
    path: 'technicalapplications',
    children: [
      {path: '', component: TechnicalApplicationListComponent},
      {
        path: 'edit/:itemId',
        component: TechnicalApplicationEditComponent,
        resolve: {
          item: TechnicalApplicationResolver
        }
      },
      {path: 'add', component: TechnicalApplicationCreateComponent}
    ],
    canActivate: [IsAdminGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TechnicalApplicationsRoutingModule { }
